import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";

import logo from './assets/images/logo_stay4golf.png';

import './custom.css';
import './mobile.css';

const Layout = (props) => {
    const [title, setTitle] = useState('');

    useEffect(() => {
        if (window.location.href.endsWith('summertour')) {
            setTitle('Välkommen till Stay4Golfs SOMMARTOURS-ANMÄLAN');
        } else if (window.location.href.endsWith('transfer')) {
            setTitle('Välkommen till Stay4Golfs transferbokning');
        } else {
            setTitle('Välkommen till Stay4Golfs anmälningssida');
        }
    }, []);

    return (
        <div className='s4g-body'>
            <div>
                <div className='s4g-banner' >
                    <a href="https://stay4golf.se/" target="_blank" rel="noopener noreferrer"><img src={logo} className='s4g-logo' alt='Logo' /></a>
                    <h1 align="center">{title}</h1>
                </div>
                <Container className='s4g-container' >
                    {props.children}
                </Container>
            </div>
            <div className="s4g-footer-wrapper">
                <div className="s4g-footer-section s4g-footer-left">
                    <div className="s4g-footer-center">
                        <h5>Följ oss</h5>
                        <a href="https://facebook.com/stay4golf" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFacebookF} className="mr-3" /></a>
                        <a href="https://www.instagram.com/stay4_golf/" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram} className="mr-3" /></a>
                    </div>
                </div>
                <div className="s4g-footer-section s4g-footer-right">
                    <div className="s4g-footer-center">
                        <h5>040 - 29 44 00</h5>
                        <h5>info@stay4golf.se</h5>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Layout;
